import * as React from "react";
import { Routes, useLocation } from "react-router-dom";
import { useDeferredNavigation } from "../contexts/DeferredNavigationContext";
import {
  LazyAdmin,
  LazyBanAppealDetail,
  LazyBlogIndex,
  LazyBlogPostDetail,
  LazySubmissionBlogForm,
  LazyBlogMySubmissions,
  LazyWarpMySubmissions,
  LazyRealEstateMySubmissions,
  LazyScreenshotMySubmissions,
  LazyCart,
  LazyCheckout,
  LazyStore,
  LazyConfirmMinecraftLink,
  LazyContact,
  LazyCreativePlotsAbout,
  LazyFishSubmission,
  LazyForumCategory,
  LazyForumBoard,
  LazyForumBoardPermissionsAdmin,
  LazyForumHome,
  LazyForumNewThread,
  LazyForumNotifications,
  LazyForumProfile,
  LazyForumThread,
  LazyGuide,
  LazyGuideHardcore,
  LazyHcGenerationsAbout,
  LazyMap,
  LazyMarkets,
  LazyMessages,
  LazyMonthlyStats,
  LazyMyAccount,
  LazyMyUpload,
  LazyNoResetSmpAbout,
  LazyPlayerProfile,
  LazyPlayers,
  LazyPlayerStatsHardcore,
  LazyPlayerStatsPvP,
  LazyPlayerStatsSMP,
  LazyPlayerStatsSMPTwoYear,
  LazyPlayerWarps,
  LazyRealEstate,
  LazyRealEstateDetail,
  LazyRealEstateForm,
  LazyRules,
  LazySiteMenuPage,
  LazySubmissionScreenshotForm,
  LazySubmissions,
  LazyUserSubmissions,
  LazyPixelPaintSubmission,
  LazyPixelPaintGallery,
  LazyOgBuilds,
  LazySupportAppeals,
  LazySupportAppealCreate,
  LazySupportHome,
  LazySupportTicketCreate,
  LazySupportTickets,
  LazyTournamentCreate,
  LazyTournamentDetail,
  LazyTournamentEdit,
  LazyTournamentMatch,
  LazyTournamentsList,
  LazyTicketDetail,
  LazyVanillaExperimentalAbout,
  LazyVerifyMagicLink,
  LazyLogin,
  LazyVillagerMarkets,
  LazyVote,
  LazyWarpDetail,
  LazyWarpSubmission,
} from "./lazyPages";
import Home from "../Pages/Home";
import { Route } from "react-router-dom";

function AppRoutes() {
  const location = useLocation();
  const { displayLocation } = useDeferredNavigation();
  const routesLocation = displayLocation || location;

  return (
    <Routes location={routesLocation}>
      <Route path="/" element={<Home />} />
      <Route path="/map" element={<LazyMap />} />
      <Route path="/players" element={<LazyPlayers />} />
      <Route path="/stats-smp" element={<LazyPlayerStatsSMP />} />
      <Route path="/stats-two-year" element={<LazyPlayerStatsSMPTwoYear />} />
      <Route path="/stats-hardcore" element={<LazyPlayerStatsHardcore />} />
      <Route path="/stats-pvp" element={<LazyPlayerStatsPvP />} />
      <Route path="/villager-markets" element={<LazyVillagerMarkets />} />
      <Route path="/markets" element={<LazyMarkets />} />
      <Route path="/rules" element={<LazyRules />} />
      <Route path="/guide" element={<LazyGuide />} />
      <Route path="/guide-hardcore" element={<LazyGuideHardcore />} />
      <Route path="/contact" element={<LazyContact />} />
      <Route path="/fish-submission" element={<LazyFishSubmission />} />
      <Route path="/vote" element={<LazyVote />} />
      <Route path="/monthly-stats" element={<LazyMonthlyStats />} />
      <Route path="/login" element={<LazyLogin />} />
      <Route path="/auth/verify/:token" element={<LazyVerifyMagicLink />} />
      <Route path="/auth/link-minecraft/:token" element={<LazyConfirmMinecraftLink />} />
      <Route path="/warps" element={<LazyPlayerWarps />} />
      <Route path="/warps/submit" element={<LazyWarpSubmission />} />
      <Route path="/warps/:id/edit" element={<LazyWarpSubmission />} />
      <Route path="/warps/:id" element={<LazyWarpDetail />} />
      <Route path="/support" element={<LazySupportHome />} />
      <Route path="/support/tickets" element={<LazySupportTickets />} />
      <Route path="/support/tickets/new" element={<LazySupportTicketCreate />} />
      <Route path="/support/appeals" element={<LazySupportAppeals />} />
      <Route path="/support/appeals/new" element={<LazySupportAppealCreate />} />
      <Route path="/support/:id" element={<LazyTicketDetail />} />
      <Route path="/support/appeals/:id" element={<LazyBanAppealDetail />} />
      <Route path="/forum/profile" element={<LazyForumProfile />} />
      <Route path="/forum/board/:boardId/category/:categoryId/new" element={<LazyForumNewThread />} />
      <Route path="/forum/board/:boardId/category/:categoryId" element={<LazyForumCategory />} />
      <Route path="/forum/board/:boardId" element={<LazyForumBoard />} />
      <Route path="/forum/category/:categoryId/new" element={<LazyForumNewThread />} />
      <Route path="/forum/category/:categoryId" element={<LazyForumCategory />} />
      <Route path="/forum/thread/:threadId" element={<LazyForumThread />} />
      <Route path="/notifications" element={<LazyForumNotifications />} />
      <Route path="/forum/notifications" element={<LazyForumNotifications />} />
      <Route path="/forum" element={<LazyForumHome />} />
      <Route path="/blog" element={<LazyBlogIndex />} />
      <Route path="/blog/:slug" element={<LazyBlogPostDetail />} />
      <Route
        path="/submissions/blog/my-submissions"
        element={<LazyBlogMySubmissions />}
      />
      <Route path="/submissions/blog/:id" element={<LazySubmissionBlogForm />} />
      <Route path="/submissions/blog" element={<LazySubmissionBlogForm />} />
      <Route
        path="/submissions/warps/my-submissions"
        element={<LazyWarpMySubmissions />}
      />
      <Route
        path="/submissions/real-estate/my-submissions"
        element={<LazyRealEstateMySubmissions />}
      />
      <Route
        path="/submissions/screenshot/my-submissions"
        element={<LazyScreenshotMySubmissions />}
      />
      <Route path="/u/:webUsername" element={<LazyPlayerProfile />} />
      <Route path="/messages/:threadId" element={<LazyMessages />} />
      <Route path="/messages" element={<LazyMessages />} />
      <Route path="/real-estate" element={<LazyRealEstate />} />
      <Route path="/real-estate/new" element={<LazyRealEstateForm />} />
      <Route path="/real-estate/:id" element={<LazyRealEstateDetail />} />
      <Route path="/real-estate/:id/edit" element={<LazyRealEstateForm />} />
      <Route path="/my-upload" element={<LazyMyUpload />} />
      <Route path="/submissions" element={<LazySubmissions />} />
      <Route path="/submissions/screenshot" element={<LazySubmissionScreenshotForm />} />
      <Route path="/submissions/pixel-paint-2026" element={<LazyPixelPaintSubmission />} />
      <Route path="/user-submissions" element={<LazyUserSubmissions />} />
      <Route path="/pixel-paint-2026" element={<LazyPixelPaintGallery />} />
      <Route path="/og-builds" element={<LazyOgBuilds />} />
      <Route path="/my-account" element={<LazyMyAccount />} />
      {/* Intentionally unlinked from all menus; store from Admin, cart from My Account. */}
      <Route path="/store" element={<LazyStore />} />
      <Route path="/cart" element={<LazyCart />} />
      <Route path="/checkout" element={<LazyCheckout />} />
      <Route path="/no-reset-smp" element={<LazyNoResetSmpAbout />} />
      <Route path="/26k-days-smp" element={<LazyNoResetSmpAbout />} />
      <Route path="/hc-generations" element={<LazyHcGenerationsAbout />} />
      <Route path="/death-ban-vanilla" element={<LazyHcGenerationsAbout />} />
      <Route path="/creative-plots" element={<LazyCreativePlotsAbout />} />
      <Route path="/vanilla-experimental" element={<LazyVanillaExperimentalAbout />} />
      <Route path="/admin" element={<LazyAdmin />} />
      <Route path="/admin/tickets/:id" element={<LazyAdmin />} />
      <Route path="/admin/appeals/:id" element={<LazyAdmin />} />
      <Route path="/admin/forum-boards" element={<LazyForumBoardPermissionsAdmin />} />
      <Route path="/tournaments" element={<LazyTournamentsList />} />
      <Route path="/tournaments/new" element={<LazyTournamentCreate />} />
      <Route path="/tournaments/:slug/edit" element={<LazyTournamentEdit />} />
      <Route path="/tournaments/:slug/matches/:matchId" element={<LazyTournamentMatch />} />
      <Route path="/tournaments/:slug" element={<LazyTournamentDetail />} />
      <Route path="/site-menu" element={<LazySiteMenuPage />} />
    </Routes>
  );
}

export default AppRoutes;
